import "./full-screen-loader.css";

/** Minimal centered loader shown while the session or a lazy chunk resolves. */
export const FullScreenLoader = () => (
  <div className="full-screen-loader" role="status" aria-label="Cargando">
    <div className="full-screen-loader-spinner" />
  </div>
);
